import { Provider } from '@angular/core';

import { provideState } from '@ngrx/store';

import { FieldStakeInputModeStrategy, StakeInputModeStrategy } from './stake-input-mode.strategy';
import { numpadFeatureKey } from './store/numpad.state';
import { numpadReducer } from './store/reducer';

export function provideNumpad(): Provider {
    return [
        {
            provide: StakeInputModeStrategy,
            useClass: FieldStakeInputModeStrategy,
        },
        provideState(numpadFeatureKey, numpadReducer),
    ];
}
